import { http } from '@/core/helpers/axiosHelper';
import { SocialSubscription } from './social-subscription.interface';

export interface SocialSubscriptionServiceInterface {
   getSocialSubscriptions(
      commuter_traffic_distance: number,
      commuter_traffic_type_id: number,
      joint_committee_number: number,
   ): Promise<SocialSubscription>;
}

export class SocialSubscriptionService implements SocialSubscriptionServiceInterface {
   async getSocialSubscriptions(
      commuter_traffic_distance: number,
      commuter_traffic_type_id: number,
      joint_committee_number: number,
   ): Promise<SocialSubscription> {
      return await http
         .get<SocialSubscription>(`/social-subscriptions`, {
            params: { commuter_traffic_distance, commuter_traffic_type_id, joint_committee_number },
         })
         .then((response) => response.data);
   }
}
